import { Row, Tooltip } from 'antd';
import styled from 'styled-components';
import tenantTheme from '@theme';
import { Flex, Icon } from '../../common';

const MutedText = styled.span`
  color: ${tenantTheme['text-color-secondary']};
`;

const CompactProduct = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
`;

// `compact`: icon and count (with `item.of`, "count/of"), the details in a tooltip (`item.tooltip`, else the name);
// each product stays whole when the row wraps.
export const Products = (props) => {
  const { products = [], compact, emptyText } = props;
  if (compact) {
    if (!products.length && emptyText) {
      return <MutedText>{emptyText}</MutedText>;
    }
    return (
      <Flex wrap align="center" gap="6px 14px">
        {products.map((item) => (
          <Tooltip key={item.id} title={item.tooltip || item.name}>
            <CompactProduct aria-label={`${item.name} ${item.quantity}${item.of != null ? `/${item.of}` : ''}`}>
              <Icon
                icon={item.icon || 'MdOutlineCircle'}
                styled
                iconProps={{ color: item.iconProps?.color, iconContainerSize: '1.6em' }}
              />
              <span>
                <span className="semiBold">{item.quantity}</span>
                {item.of != null && <MutedText>/{item.of}</MutedText>}
              </span>
            </CompactProduct>
          </Tooltip>
        ))}
      </Flex>
    );
  }
  return (
    <>
      <Row>
        {products.map((item, index) => {
          return (
            <Flex align="center" gap="4px" style={{ marginInlineEnd: 4 }} key={item.id}>
              <Icon
                icon={item?.icon || 'MdOutlineCircle'}
                styled
                iconProps={{ color: item?.iconProps?.color, iconContainerSize: '1.6em' }}
              />
              <div>
                {item?.name} ({item?.quantity}){index !== products.length - 1 && ', '}
              </div>
            </Flex>
          );
        })}
      </Row>
    </>
  );
};
